import React from 'react';

const Spacer = () => <div style={{ marginBottom: 16 }} />;

export default Spacer;
